import { render, staticRenderFns } from "./PageRegister.vue?vue&type=template&id=16ebe114&"
import script from "./PageRegister.vue?vue&type=script&lang=js&"
export * from "./PageRegister.vue?vue&type=script&lang=js&"
import style0 from "./PageRegister.vue?vue&type=style&index=0&id=16ebe114&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports